import React, { useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import TableContainer from "../../components/layout/table-container/table-container";
import { manufacturerVersionList } from "../../redux/actions/manufacturerActions";
import ManufacturerVersionTableData from "./manufacturer-version-table-data";
import UpArrow from "../../assets/icons/filterArrowUp.svg";
import DownArrow from "../../assets/icons/filterArrowDown.svg";
import LoadingSpinnerTable from "../../components/utilites/loaderSpinningContainer";
import { useNavigate, useParams } from "react-router-dom";
import NumberPagination from "../../components/Pagination/number-pagination";

const ManufacturerVersionTable = ({ search, page_no, status }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const componentRef = useRef();
  const [page, setPage] = useState(page_no ? page_no : 1);
  const [openStatus, setOpenStatus] = useState(false);
  const [manufacturerVersionListData, setManufacturerVersionListData] =
    useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (page_no) {
      setPage(page_no);
    }
  }, [page_no]);

  useEffect(() => {
    setLoading(true);
    dispatch(
      manufacturerVersionList({ page, search, status }, onSuccess, onError)
    );
  }, [page, status, search]);

  const onSuccess = (data) => {
    setManufacturerVersionListData(data.data.data);
    setLoading(false);
  };

  const onError = (err) => {
    setLoading(false);
  };

  const handleClickOutside = (event) => {
    if (componentRef.current && !componentRef.current.contains(event.target)) {
      setOpenStatus(false);
    }
  };

  useEffect(() => {
    if (openStatus) {
      document.addEventListener("click", handleClickOutside);
    } else {
      document.removeEventListener("click", handleClickOutside);
    }
    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, [openStatus]);

  const queryParams = [];
  if (search) queryParams.push(`search=${search}`);
  if (status) queryParams.push(`status=${status}`);

  const queryString = queryParams.length > 0 ? `&${queryParams.join("&")}` : "";
  return (
    <>
      <TableContainer>
        <thead>
          <tr className="table-rows color_747f9e">
            <th className="table-heads " width={"4%"}>
              #
            </th>
            <th className="table-heads " width={"10%"}>
              Manufacturer ID
            </th>
            <th className="table-heads " width={"12%"}>
              Manufacturer Name
            </th>
            <th className="table-heads " width={"6%"}>
              No. of Orders
            </th>
            <th className="table-heads " width={"6%"}>
              No. of Distributors
            </th>
            <th ref={componentRef} className="table-heads " width={"8%"}>
              <span
                className={
                  openStatus
                    ? "Medium_Purple cursor_pointer "
                    : "cursor_pointer"
                }
                onClick={() => setOpenStatus(!openStatus)}
              >
                <span className={status ? "Medium_Purple fw_700" : ""}>
                  Status
                </span>
                {openStatus ? (
                  <img src={UpArrow} className="mb-1 mx-1" alt="v" />
                ) : (
                  <img src={DownArrow} className="mx-1" alt="v" />
                )}
              </span>
              {openStatus && (
                <div className=" position-relative">
                  <div className="position-absolute status-container d-flex gap-3 px-3">
                    <div className="d-flex align-items-center ">
                      <input
                        className="radio me-2 cursor_pointer"
                        type="radio"
                        id="Active"
                        name="status"
                        value={"active"}
                        checked={status === "active"}
                        onClick={(e) => {
                          setOpenStatus(!openStatus);
                          navigate(
                            `/manufacturer/subscibe-list/version-list?page=1${
                              search ? `&search=${search}` : ""
                            }&status=active`
                          );
                        }}
                      />
                      <label
                        htmlFor="Active"
                        className={
                          status === "active"
                            ? "color_262c3d cursor_pointer"
                            : "color_747f9e cursor_pointer"
                        }
                      >
                        Active
                      </label>
                    </div>
                    <div className="d-flex align-items-center ">
                      <input
                        className="radio me-2 cursor_pointer"
                        type="radio"
                        id="Inactive"
                        name="status"
                        value={"inactive"}
                        checked={status === "inactive"}
                        onClick={(e) => {
                          setOpenStatus(!openStatus);
                          navigate(
                            `/manufacturer/subscibe-list/version-list?page=1${
                              search ? `&search=${search}` : ""
                            }&status=inactive`
                          );
                        }}
                      />
                      <label
                        htmlFor="Inactive"
                        className={
                          status === "inactive"
                            ? "color_262c3d cursor_pointer"
                            : "color_747f9e cursor_pointer"
                        }
                      >
                        Inactive
                      </label>
                    </div>
                    <div className="d-flex align-items-center ">
                      <input
                        className="radio me-2 cursor_pointer"
                        type="radio"
                        id="draft"
                        name="status"
                        value={"draft"}
                        checked={status === "draft"}
                        onClick={(e) => {
                          setOpenStatus(!openStatus);
                          navigate(
                            `/manufacturer/subscibe-list/version-list?page=1${
                              search ? `&search=${search}` : ""
                            }&status=draft`
                          );
                        }}
                      />
                      <label
                        htmlFor="draft"
                        className={
                          status === "draft"
                            ? "color_262c3d cursor_pointer"
                            : "color_747f9e cursor_pointer"
                        }
                      >
                        Draft
                      </label>
                    </div>

                    <button
                      className="filter-btn px-2 py-0 my-2 fs_12"
                      style={{ height: "28px" }}
                      onClick={() => {
                        setOpenStatus(!openStatus);
                        navigate(
                          `/manufacturer/subscibe-list/version-list?page=1${
                            search ? `&search=${search}` : ""
                          }`
                        );
                      }}
                    >
                      CLEAR
                    </button>
                  </div>
                </div>
              )}
            </th>
            <th className="table-heads " width={"18%"}>
              Actions
            </th>
          </tr>
        </thead>
        {loading === true ? (
          <div className="spinner-container">
            <LoadingSpinnerTable show={loading} />
          </div>
        ) : manufacturerVersionListData?.Manufacturer?.length > 0 ? (
          <>
            {manufacturerVersionListData?.Manufacturer?.map(
              (eachRow, index) => (
                <ManufacturerVersionTableData
                  key={eachRow.id}
                  data={eachRow}
                  index={index}
                  currentPage={
                    manufacturerVersionListData?.pagination?.currentPage
                  }
                />
              )
            )}
          </>
        ) : (
          <>
            <div>
              <tr className="nodata-container">~ No Data found ~</tr>
            </div>
          </>
        )}
      </TableContainer>
      <div className={loading === true ? `loading-event` : ""}>
        {manufacturerVersionListData?.pagination?.totalPages > 0 && (
          <NumberPagination
            setCurrentPage={setPage}
            pagination={manufacturerVersionListData?.pagination?.currentPage}
            totalPages={manufacturerVersionListData?.pagination?.totalPages}
            path={"/manufacturer/subscibe-list/version-list"}
            filters={`${queryString}`}
          />
        )}
      </div>
    </>
  );
};

export default ManufacturerVersionTable;
